<template>
	<layout-admin>
		<div class="pb-18 divide-y-2 divide-gray-200">
			<ui-alert
				v-if="success"
				type="success"
				message="Your inputs have been saved!"
			/>

			<div class="p-6">
				<h1 class="text-2xl font-semibold text-gray-900 mb-4">
					{{ __(offer.trade == "BUY" ? "Buy Offer" : "Sell Offer") }} #{{
						offer.id
					}}
					{{ __("by") }} {{ offerUser.company_name }}
				</h1>

				<div class="fixed bottom-0 left-0 px-6 pt-4 pb-9 z-15">
					<ui-button
						class="flex gap-x-2 items-center text-xl font-bold shadow-xl"
						label="Save"
						v-on:click="submitForm()"
						:disabled="submitButtonDisabled"
					>
						<ui-icon
							class="flex-shrink-0 h-6 w-6 -ml-1"
							name="save"
							stroke-width="1.5"
						/>
						{{ __("Save") }}
					</ui-button>
				</div>

				<ui-button
					label="Flächengebot bearbeiten"
					class="flex space-x-2 items-center"
					v-on:click="
						$inertia.visit(
							$route('admin.offers_buy_price_indication', { id: offer.id })
						)
					"
					v-if="showEditPriceIndication"
				>
					Flächengebot bearbeiten
					<ui-icon
						class="ml-2 -mr-1 flex-shrink-0 h-5 w-5"
						name="chevron-right"
						stroke-width="1.5"
					/>
				</ui-button>
			</div>

			<offer-edit-step1
				:offer="offer"
				:user="offerUser"
				:form="form"
				:creating="false"
				:showEditPriceIndication="canEnablePriceIndication"
			/>

			<offer-edit-step2
				:offer="offer"
				:user="offerUser"
				:form="form"
				:activeFutures="activeFutures"
			/>

			<offer-edit-step3 :offer="offer" :user="offerUser" :form="form" />

			<offer-edit-auction
				v-if="offer.trade == 'SELL' && adminUser.role == 'ADMIN'"
				:offer="offer"
				:user="offerUser"
				:form="form"
			/>

			<thread-short-list
				:data="threads"
				:user="offerUser"
				:form="form"
				v-if="canCreateNegotiation"
			/>
		</div>
	</layout-admin>
</template>

<script>
export default {
	props: {
		offer: {
			type: Object,
			required: true,
		},
		offerUser: {
			type: Object,
			required: true,
		},
		userUploads: {
			type: Array,
			required: true,
		},
		activeFutures: {
			type: Array,
			required: true,
		},
		success: {
			type: Boolean,
			default: false,
		},
		threads: {
			type: Array,
			required: true,
		},
	},
	data() {
		return {
			adminUser: this.$inertia.page.props.user,
			form: Vue.observable(
				this.$inertia.form(JSON.parse(JSON.stringify(this.offer)))
			),
			submitButtonDisabled: false,
		};
	},
	computed: {
		showEditPriceIndication() {
			if (this.canEnablePriceIndication) {
				return this.offer.priceindication.enabled == true;
			}
			return false;
		},
		canEnablePriceIndication() {
			return (
				this.offer.trade == "BUY" &&
				["ADMIN", "ADMIN_LIGHT"].includes(this.adminUser.role)
			);
		},
		canCreateNegotiation() {
			return ["ADMIN", "ADMIN_LIGHT"].includes(this.adminUser.role);
		},
	},
	methods: {
		async submitForm() {
			let endpoint = this.$page.url,
				method = "patch",
				that = this;

			this.submitButtonDisabled = true;
			this.form.submit(method, endpoint, {
				preserveState: true,
				onSuccess(p) {
					console.log("SUCCESS SUBMISSION, got: ", p);
				},
				onFinish(e) {
					that.submitButtonDisabled = false;
					console.log("submit FINISH", method, endpoint, "got:", e);
				},
			});
		},
	},
};
</script>
